import {useTranslation} from 'react-i18next';

import TableNotFound from '@/components/data-table/TableNotFound';
import TablePagination from '@/components/data-table/TablePagination';
import {useTable} from '@/components/data-table/useTable';
import {Button} from '@/components/ui/button';
import type {DialogProps} from '@/components/ui/dialog';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSection,
  DialogTitle,
} from '@/components/ui/dialog';
import {useEvents} from '@/hooks/useEvents';

import {eventsColumns} from '../utils/eventsColumns';
import EventListView from './EventListView';

export type EventListDialogProps = DialogProps;

const EventListDialog = ({onOpenChange, ...props}: EventListDialogProps) => {
  const {t} = useTranslation();

  const {events} = useEvents({
    enabled: props.open,
  });

  const table = useTable({
    columns: eventsColumns,
    data: events,
    initialState: {
      pagination: {
        pageSize: 5,
      },
    },
  });

  return (
    <Dialog {...props} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('Recent events')}</DialogTitle>
        </DialogHeader>
        <DialogSection>
          <EventListView table={table} paperProps={{variant: 'white'}} />
          <TableNotFound table={table} />
          <TablePagination table={table} />
        </DialogSection>
        <DialogFooter>
          <Button
            variant="primary"
            type="button"
            onClick={() => onOpenChange?.(false)}
          >
            {t('Close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EventListDialog;
